import { render, staticRenderFns } from "./DynamicAvatar.vue?vue&type=template&id=03f66d12&scoped=true"
import script from "./DynamicAvatar.vue?vue&type=script&lang=js"
export * from "./DynamicAvatar.vue?vue&type=script&lang=js"
import style0 from "./DynamicAvatar.vue?vue&type=style&index=0&id=03f66d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f66d12",
  null
  
)

export default component.exports